module.exports = __webpack_public_path__ + "static/img/34.7c4de38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/34.png
// module id = hVQO
// module chunks = 0